import {useQuery} from "react-query";
import axios from "axios";
import {useSnackbar} from "notistack";

const apiUrl = "api/skid/instant-data";

const fetchPowerStationInstantData = async (powerStationId: number, skidId: number) => {
    try {
        const response = await axios.get(`${apiUrl}/${powerStationId}/${skidId}`);

        return {
            data: response.data.data,
            status: response.status
        }
    } catch (error) {
        console.error("Error fetching data:", error);
        throw new Error("Error fetching data");
    }
};

export const FindInstantDataByPowerStationReactQuery = (powerStationId:number, skidId: number) => {
    const { enqueueSnackbar } = useSnackbar();
    return useQuery({
        queryKey: ['skid-instant-data', powerStationId, skidId],
        queryFn: () => fetchPowerStationInstantData(powerStationId,skidId),
        onError: (error: any) => {
            enqueueSnackbar(`Erro ao carregar dados de geração de energia: ${error.message}`, { variant: "error" });
        },
        enabled: powerStationId != null && skidId != null
    })
};